import RestaurantsList from 'components/Lists/ListView/RestaurantsList';
import Text from 'components/Text/Text';
import React, { useState } from 'react';
import { IItemModifierGroups } from 'types';
import DataController from 'components/DataController/DataController';
import Info from './components/Info/Info';
import classNames from 'classnames';
import style from './Item.module.scss';

interface IItem {
	data: IItemModifierGroups;
	index: number;
	setIDForDeletion: (value: string) => void;
}

const Item: React.FC<IItem> = ({ data, index, setIDForDeletion }) => {
	const [isOpenInfo, setIsOpenInfo] = useState<boolean>(false);

	const containerClasses = classNames(style.container, { [style.openInfo]: isOpenInfo });
	const nameRowClasses = classNames(style.name, style.row);
	const articleNumberHeadingClasses = classNames(style.articleNumber, style.heading);
	const restaurantRowClasses = classNames(style.restaurant, style.row, style.list);
	const customerRowClasses = classNames(style.customer, style.row);
	const actionRowClasses = classNames(style.action, style.row);

	const restaurants = data.restaurantsModifierGroups.map((el) => ({
		...el,
		id: el.restaurantId,
	}));

	return (
		<div data-test={`Item-${index}`}>
			<div className={containerClasses}>
				<Text className={nameRowClasses} translationKey={data.name} withTooltip={true} />
				<Text className={articleNumberHeadingClasses} translationKey={data.articleNumber} withTooltip={true} />
				<div className={restaurantRowClasses}>
					<RestaurantsList restaurants={restaurants} />
				</div>
				<Text className={customerRowClasses} translationKey={data.customerName} withTooltip={true} />
				<div className={actionRowClasses}>
					<DataController
						onClickInfo={() => setIsOpenInfo(!isOpenInfo)}
						onClickDelete={() => setIDForDeletion(data.id)}
						URLWithIDToEdit={`/menu/modifier-groups/edit?modifierGroupsID=${data.id}`}
						size="smallBtn"
						isOpenInfo={isOpenInfo}
					/>
				</div>
			</div>
			<Info isOpenInfo={isOpenInfo} data={data} />
		</div>
	);
};

export default React.memo(Item);
